import api, { API_BASE, defaultOpt } from "./apiService";
import { filterTable, rowTransform } from "./tableUtils";

export async function getAllMaterial() {
  return (await api.get(`${API_BASE}/list-material`)).data;
}

export async function addMaterial(form) {
  return (await api.post(`${API_BASE}/add-material`, form, defaultOpt())).data;
}

export async function deleteMaterial(id) {
  return (await api.delete(`${API_BASE}/delete-material/${id}`, defaultOpt()))
    .data;
}

export async function updateMaterial(id, form) {
  return (
    await api.put(`${API_BASE}/update-material/${id}`, form, defaultOpt())
  ).data;
}

export const materialTypeOptions = [
  { value: "CuW", label: "CuW" },
  { value: "Ti", label: "Ti" },
];

export function makeMaterialOptions(matList, hideExhaust = false) {
  let options = filterTable(matList, (mat) =>
    hideExhaust ? mat.in_stock : true,
  );
  return rowTransform(options, (mat) => ({
    value: mat.id,
    label: `${mat.batch_id} (${mat.shorthand})`,
    available: mat.in_stock,
  }));
}

export function materialDescription(matList, id) {
  const mat = filterTable(matList, (mat) => mat.id === id);
  return mat ? `${mat.shorthand} (${mat.type} ${mat.batch_id})` : "";
}

const __s_map__ = {
  ATTL: "ATTL Advanced Materials (CERN/CN)",
  CuWDE: "KIT Private purchase (DE)",
  IITM: "IIT Madras",
  TiDE: "KIT Private purchase (DE)",
  WHS: "KIT Private order (DE)",
};

export function materialSourceDisplay(s) {
  return s in __s_map__ ? `[${s}] ${__s_map__[s]}` : "UNKNOWN";
}

export const materialSourceOptions = Object.keys(__s_map__).map((k) => ({
  value: k,
  label: __s_map__[k],
}));
